//const Game = require('@/tbs/model/to/Game')
//const game = new Game

/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_GameStats = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_GameStats.prototype = {
    /* The view object name */
    name: 'playerList',
    /* The view object instance */
    view: {
        manage: [
            {
                name: 'homeTeamPlayers',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetBMBktGameEventPlayerList',
                basePath: 'data.playerList',
                rule: {
                    id: 'id',
                    name: 'trueName',
                    label: '$trueName,number',
                    value: 'id',
                    num: 'number',
                }
            },
            {
                name: 'awayTeamPlayers',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetBMBktGameEventPlayerList',
                basePath: 'data.playerList',
                rule: {
                    id: 'id',
                    name: 'trueName',
                    label: '$trueName,number',
                    value: 'id',
                    num: 'number',
                }
            },
        ],
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmteam/',
            service: 'getBMGameEvents',
            basePath: 'data.gamePlayers',
            rule: {
                id: 'id',
                teamId: 'teamId',
                name: 'trueName',
                label: '$trueName,number',
                value: 'id',
                num: 'number',
                goalCount: 'goalCount',
                penaltyGoalCount: 'penaltyCount',
                ownGoalCount: 'ownGoalCount',
                assistCount: 'assistCount',
                yellowCardCount: 'yellowCardCount',
                redCardCount: '$yellowCardCount,redCardCount',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmteam/',
            service: 'getBMPlayerGameEvents',
            basePath: 'data.gamePlayer',
            rule: {
                id: 'id',
                teamId: 'teamId',
                name: 'trueName',
                label: '$trueName,number',
                value: 'id',
                num: 'number',
                goalCount: 'goalCount',
                penaltyGoalCount: 'penaltyCount',
                ownGoalCount: 'ownGoalCount',
                assistCount: 'assistCount',
                yellowCardCount: 'yellowCardCount',
                redCardCount: '$yellowCardCount,redCardCount',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'BMMatchOrganizationUpdateBMGameEvents2.json',
            basePath: '',
            rule: {
                playerId: 'id',
                teamId: 'teamId',
                gameId: 'gameId',
                goal: 'goalCount',
                penalty: 'penaltyGoalCount',
                ownGoal: 'ownGoalCount',
                assist: 'assistCount',
                yellow: 'yellowCardCount',
                red: 'redCardCount',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'BMMatchOrganizationUpdateBMGameEvents2.json',
            basePath: '',
            rule: {
                playerId: 'id',
                teamId: 'teamId',
                gameId: 'gameId',
                goal: 'goalCount',
                penalty: 'penaltyGoalCount',
                ownGoal: 'ownGoalCount',
                assist: 'assistCount',
                yellow: 'yellowCardCount',
                red: 'redCardCount',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderRedCardCount: function(yellowCardCount,redCardCount) {
        if (yellowCardCount == 2) {
            return 0
        }
        else if (redCardCount > 1) {
            return 1
        }
        else {
            return redCardCount
        }
    },
    renderLabel: function(trueName, number) {
        return (number ? number : '') + ' ' + trueName
    }
}

module.exports = tbs_model_vo_GameStats